export default __webpack_public_path__ + "img/261ae742cca105c252ad650738c18289.png";